import { render } from "./EditServiceReport2.vue?vue&type=template&id=134d5eae"
import script from "./EditServiceReport2.vue?vue&type=script&lang=js"
export * from "./EditServiceReport2.vue?vue&type=script&lang=js"

import "./EditServiceReport2.vue?vue&type=style&index=0&id=134d5eae&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__